import { render, staticRenderFns } from "./add-child-product-modal.vue?vue&type=template&id=0e7165d8&scoped=true&"
import script from "./add-child-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-child-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-child-product-modal.vue?vue&type=style&index=0&id=0e7165d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7165d8",
  null
  
)

export default component.exports